<template>
<svg viewBox="0 0 20 20">
    <path fill="currentColor" d="M0 11l2-2 5 5 11-11 2 2-13 13z"></path>
</svg>
</template>
